<app-nav-bar></app-nav-bar>
<div class="container-fluid screamble-app-design">
  <div class="heading-for-topics">
    <h6>{{ "Articles" | translate }}</h6>
  </div>
  <div class="difference-head-top">
    <app-language-dropdown [type]="lang"
      (passTranslationParent)="changeTranslation($event)"
    ></app-language-dropdown>
  </div>
  <div class="row screamble-app">
    <ng-container *ngIf="articlesList.length > 1; else empty">
      <div
        class="col-sm-12 col-md-4 col-lg-4"
        *ngFor="let article of articlesList; let i = index"
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="3000"
        (scrolled)="onScroll()"
      >
        <div
          class="image-india"
          [routerLink]="['/article-detail', article.ArticleId, translationId]"
        >
          <img
            src="{{ article.ArticleImageUrl }}"
            alt=""
            class="image-of-sura"
          />
          <div class="bottom-hell">
            <h1>
              <a class="topic-name-anchor" href="javascript:void(0);">{{
                article.ArticleNames[0].Name
              }}</a>
            </h1>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #empty>...</ng-template>
  </div>
</div>
